import * as api from './api';
import { SdkError, ApiError } from './error';
import CommerceLayer, { OPEN_API_SCHEMA_VERSION } from './commercelayer';
/* Static functions */
export const CommerceLayerStatic = {
    resources: () => {
        return api.resourceList;
    },
    isSdkError: (error) => {
        return SdkError.isSdkError(error);
    },
    isApiError: (error) => {
        return ApiError.isApiError(error);
    },
    init: (config) => {
        return CommerceLayer(config);
    },
    get schemaVersion() { return OPEN_API_SCHEMA_VERSION; }
};
